import ApiService from './api.service'
const main = '/vacancy'

const RegionService = {
    listAll: async function () {
        return ApiService.get(`${main}/region-list`)
    },
    getParent: async function () {
        return ApiService.get(`${main}/region-listByParent`)
    },
    getByParentId: async function (id) {
        return ApiService.get(`${main}/region-listByParentId/${id}`)
    }
}

export default RegionService;
